import _ from 'lodash';
let fetch;
/* @ngInject */
export default class DashboardInfoService {
    $rootscope;
    $q;
    $sails;
    // TODO: Refactor this class into a reusable/extendable base service
    // This is a very particular pattern we (incorrectly) use a lot
    // (See: refresh assignment/merge)
    // it would be helpful to just reuse a simple class underneath
    constructor($rootScope, $q, $sails) {
        'ngInject';
        this.$rootscope = $rootScope;
        this.$q = $q;
        this.$sails = $sails;
        // Subscribe to dashboard socket room
        $sails.post('/dashboard/join')
            .catch(err => console.error('Could not join dashboard room', err));
        // eslint-disable-next-line angular/on-watch
        $rootScope.$on('dashboard:created', (__, board) => this.add(board));
        // eslint-disable-next-line angular/on-watch
        $rootScope.$on('dashboard:destroyed', (__, board) => this.destroy(board));
    }
    #dashboards = {};
    get dashboards() {
        return _.sortBy(Object.values(this.#dashboards), ({ name }) => name.toLowerCase());
    }
    getDashboard(id) {
        return this.#dashboards[id];
    }
    getEquipment(dashboard) {
        // TODO: Consolidate this with DashboardService method
        const equipment = [];
        _.forEach(dashboard.panels, (panel) => {
            if (Array.isArray(panel.equipment)) {
                equipment.push(...panel.equipment);
            }
        });
        return _.uniq(equipment);
    }
    async refreshDashboardListFromServer() {
        try {
            // TODO: Rework this select to be configurable
            fetch = fetch || this.$sails.get('/dashboards/?select=name');
            const { data: boards } = await fetch;
            // TODO: Make this refresh preserve any references instead of re-assigning
            this.#dashboards = _.keyBy(boards, 'id');
        }
        finally {
            fetch = undefined;
        }
    }
    add(dashboard) {
        this.#dashboards[dashboard.id] = dashboard;
    }
    destroy(dashboard) {
        delete this.#dashboards[dashboard.id];
    }
    async getAllDashboards() {
        if (_.isEmpty(this.#dashboards)) {
            await this.refreshDashboardListFromServer();
        }
        return this.dashboards;
    }
}
